import usePageTitle from './usePageTitle';

export { usePageTitle };
